import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link, useLocation } from 'react-router-dom';
import OptimizedImage from './OptimizedImage';
import { parseData } from '../../../lib/helpers';
import { useFptiImpression } from '../../../lib/hooks';
import { Button } from '@paypalcorp/pp-react';

import { AMPLITUDE } from '../../../lib/constants';

const { MAIN_COLLECTION_HERO_BANNER_CLICK } = AMPLITUDE;

const CollectionsHeroBanner = props => {
  const {
    collection = {},
    collectionsTitle,
    fptiClick,
    fptiImpression,
    isSingleton
  } = props;
  const {
    heroImage,
    fptiHeroBannerName,
    title,
    subtitle,
    buttonText,
    isDarkTheme,
    fptiLinkName,
    location: to
  } = collection;
  const location = useLocation();

  const ref = useRef();
  useFptiImpression(ref, () => {
    fptiImpression({
      pageLink: fptiLinkName,
      category: 'parent'
    });
  });

  const image = parseData(heroImage)[0];
  const backgroundColor = image?.backgroundColor;
  const imageUrl = image?.url;
  const isImageBottomAligned = image?.isBottomAligned;

  const handleClick = fptiLink => {
    fptiClick({
      fptiLink: (typeof fptiLink === 'string' && fptiLink) || fptiLinkName,
      category: 'parent',
      pageLink: fptiLinkName,
      type: fptiHeroBannerName,
      amplitude: true,
      event_name: MAIN_COLLECTION_HERO_BANNER_CLICK
    });
  };

  const [windowWidth, setWindowWidth] = useState(0);
  const resizeWindow = () => {
    setWindowWidth(window.innerWidth);
  };
  useEffect(() => {
    resizeWindow();
    window.addEventListener('resize', resizeWindow);
    return () => window.removeEventListener('resize', resizeWindow);
  }, []);

  const updateBgColor = () => {
    if (fptiLinkName && windowWidth <= 1059) {
      if (fptiLinkName.includes('power-up-checkout')) {
        return { backgroundColor: '#308A67' };
      } else if (fptiLinkName.includes('payment-tools')) {
        return { backgroundColor: '#FFC43A' };
      } else if (fptiLinkName.includes('take-payments')) {
        return { backgroundColor: '#fafafa' };
      }
    }
    return {};
  };

  return (
    <Link
      className={`collections-hero-banner undo-link-styles add-focus-visible ${
        isSingleton ? 'singleton' : ''
      }`}
      to={{
        pathname: `/businesstools/collection/${to}`,
        state: { prevPath: location.pathname }
      }}
      onClick={handleClick}
    >
      <div
        className="banner-wrapper"
        style={{ backgroundColor: backgroundColor }}
        ref={ref}
      >
        <div className="banner-row">
          <div className="banner-col-left">
            <div className="banner-content">
              <div
                className={
                  isDarkTheme === 'TRUE'
                    ? `banner-content-text dark`
                    : 'banner-content-text'
                }
              >
                <h6 className="banner-content-super">{collectionsTitle}</h6>
                <h2 className="banner-content-heading">{title}</h2>
                <h4 className="banner-content-subheading">{subtitle}</h4>
                <div>
                  <Button
                    style={{
                      // color: '#0070ba',
                      width: 'max-content',
                      marginTop: '10px'
                    }}
                    size="sm"
                    secondary
                  >
                    {buttonText}
                  </Button>
                </div>
              </div>
            </div>
          </div>
          <div
            style={windowWidth < 1059 ? updateBgColor() : {}}
            className="banner-col-right"
          >
            <div className="banner-inner">
              <div
                className={
                  isImageBottomAligned
                    ? 'banner-content-media bottom-aligned'
                    : 'banner-content-media'
                }
              >
                <OptimizedImage
                  imageUrl={imageUrl}
                  windowWidth={windowWidth}
                  className={'banner-content-image'}
                  disableOptimization
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};

CollectionsHeroBanner.propTypes = {
  collection: PropTypes.object,
  collectionsTitle: PropTypes.string,
  fptiClick: PropTypes.func,
  fptiImpression: PropTypes.func,
  isSingleton: PropTypes.bool
};

export default CollectionsHeroBanner;
